import "./style.css";

import { CourseTeacherBio } from "../../components/CourseTeacherBio";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

export const CourseLandingTeachers = ({ teachers, language }) => {

  const title_translations = {
    "es": "Otros Masters que participan en este Programa:",
    "en": "Other Masters participating in this Program:",
    "fr": "Autres Masters participant à ce programme:",
    "pt": "Outros Mestres que participam neste Programa:",
    "ru": "Другие мастера, участвующие в этой программе:"};

  const translations = {
    "es": [
      {
        name: "Tim Beijsens",
        style: "Blackwork",
        image: "https://m.10masters.com/images/timportraitweb.height-246.format-webp.webp"
      },
      {
        name: "Coreh López",
        style: "Realismo",
        image: "https://m.10masters.com/images/coreh11.height-246.format-webp.webp"
      },
      {
        name: "Monlix",
        style: "Single Needle",
        image: "https://m.10masters.com/images/FOTO_PERFIL_WEB_MONLIX.height-246.format-webp.webp"
      },
      {
        name: "Turkesa",
        style: "Neotradicional",
        image: "https://m.10masters.com/images/turkesa-100X100.original.jpg"
      },
      {
        name: "Rebollo",
        style: "Blackwork",
        image: "https://m.10masters.com/images/rebollo-profile.height-246.format-webp.webp"
      }
    ],

    "en": [
      {
        name: "Tim Beijsens",
        style: "Blackwork",
        image: "https://m.10masters.com/images/timportraitweb.height-246.format-webp.webp"
      },
      {
        name: "Coreh López",
        style: "Realism",
        image: "https://m.10masters.com/images/coreh11.height-246.format-webp.webp"
      },
      {
        name: "Monlix",
        style: "Single Needle",
        image: "https://m.10masters.com/images/FOTO_PERFIL_WEB_MONLIX.height-246.format-webp.webp"
      },
      {
        name: "Turkesa",
        style: "Neotraditional",
        image: "https://m.10masters.com/images/turkesa-100X100.original.jpg"
      },
      {
        name: "Rebollo",
        style: "Blackwork",
        image: "https://m.10masters.com/images/rebollo-profile.height-246.format-webp.webp"
      }
    ],

    "fr": [
      {
        name: "Tim Beijsens",
        style: "Blackwork",
        image: "https://m.10masters.com/images/timportraitweb.height-246.format-webp.webp"
      },
      {
        name: "Coreh López",
        style: "Réaliste",
        image: "https://m.10masters.com/images/coreh11.height-246.format-webp.webp"
      },
      {
        name: "Monlix",
        style: "Single Needle",
        image: "https://m.10masters.com/images/FOTO_PERFIL_WEB_MONLIX.height-246.format-webp.webp"
      },
      {
        name: "Turkesa",
        style: "Neotraditional",
        image: "https://m.10masters.com/images/turkesa-100X100.original.jpg"
      },
      {
        name: "Rebollo",
        style: "Blackwork",
        image: "https://m.10masters.com/images/rebollo-profile.height-246.format-webp.webp"
      }
    ],

    "pt": [
      {
        name: "Tim Beijsens",
        style: "Blackwork",
        image: "https://m.10masters.com/images/timportraitweb.height-246.format-webp.webp"
      },
      {
        name: "Coreh López",
        style: "Realismo",
        image: "https://m.10masters.com/images/coreh11.height-246.format-webp.webp"
      },
      {
        name: "Monlix",
        style: "Single Needle",
        image: "https://m.10masters.com/images/FOTO_PERFIL_WEB_MONLIX.height-246.format-webp.webp"
      },
      {
        name: "Turkesa",
        style: "Neotradicional",
        image: "https://m.10masters.com/images/turkesa-100X100.original.jpg"
      },
      {
        name: "Rebollo",
        style: "Blackwork",
        image: "https://m.10masters.com/images/rebollo-profile.height-246.format-webp.webp"
      }
    ],
    "ru": [
      {
        name: "Tim Beijsens",
        style: "Blackwork",
        image: "https://m.10masters.com/images/timportraitweb.height-246.format-webp.webp"
      },
      {
        name: "Coreh López",
        style: "Реализм",
        image: "https://m.10masters.com/images/coreh11.height-246.format-webp.webp"
      },
      {
        name: "Monlix",
        style: "Single Needle",
        image: "https://m.10masters.com/images/FOTO_PERFIL_WEB_MONLIX.height-246.format-webp.webp"
      },
      {
        name: "Turkesa",
        style: "Neotraditional",
        image: "https://m.10masters.com/images/turkesa-100X100.original.jpg"
      },
      {
        name: "Rebollo",
        style: "Blackwork",
        image: "https://m.10masters.com/images/rebollo-profile.height-246.format-webp.webp"
      }
    ]
  };


  if (document.body.clientWidth <= 576)
    return (
      <>
        <Swiper
          centeredSlides={true}
          slidesPerView={1.25}
          observer={false}
          observeParents={false}
          spaceBetween={'10'}
          rewind={false}
          navigation={false}
          pagination={{
            enabled: true,
            clickable: true
          }}
          modules={[Pagination, Navigation]}
          className="course_landing_image_gallery_mobile"
        >
          {
            teachers.map((teacher) => {

              return (
                <SwiperSlide key={teacher.name}>
                  <CourseTeacherBio
                    key={teacher.name}
                    name={teacher.name}
                    subtitle={teacher.undertitle}
                    description={teacher.bio}
                    image={teacher.image}
                  />
                </SwiperSlide>
              );

            })
          }
        </Swiper>
        
        <h3 className="multi_teachers_title">{ title_translations[language] }</h3>
        <div className="multi_teachers">
          {translations[language].map((translation) => (
            <div key={translation.name} className="teacher_block">
              <img className="multi_teacher_img" src={translation.image} alt={translation.name} />
              <div className="multi_teacher_name">{translation.name}</div>
              <div className="multi_teacher_style">{translation.style}</div>
            </div>
          ))}
        </div>
      </>
    );

    return (
      <>
        {teachers.map((teacher) => (
          <CourseTeacherBio
            key={teacher.name}
            name={teacher.name}
            subtitle={teacher.undertitle}
            description={teacher.bio}
            image={teacher.image}
          />
        ))}
    
        <h3 className="multi_teachers_title">{ title_translations[language] }</h3>
        <div className="multi_teachers">
          {translations[language].map((translation) => (
            <div key={translation.name} className="teacher_block">
              <img className="multi_teacher_img" src={translation.image} alt={translation.name} />
              <div className="multi_teacher_name">{translation.name}</div>
              <div className="multi_teacher_style">{translation.style}</div>
            </div>
          ))}
        </div>
      </>
    );
    

};
